// extracted by mini-css-extract-plugin
module.exports = {"content":"CommonGeneral_content__ZeG1X","detail":"CommonGeneral_detail__13G8c","row":"CommonGeneral_row__2Qhfz"};